


<akeela-auth-create-user-password   [username]="username"  [token]="token"  [config]="config"  (response)="getResponse($event)" *ngIf="username && token && config"
></akeela-auth-create-user-password>
